module.exports = __webpack_public_path__ + "img/ico-filter-arrow.9f08b8f4.svg";